(function () {
  if (window.Eurus && window.Eurus.loadedScript) {
    if (window.Eurus.loadedScript.has('ugc-videos.js')) return;
    window.Eurus.loadedScript.add('ugc-videos.js');
  }

  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_PREV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function play(video) {
    if (!video) return;
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isConstrainedDevice() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(connection && (connection.saveData || /2g/.test(connection.effectiveType || '')));
    var lowMemory = typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 2;
    return saveData || lowMemory;
  }

  function createModal() {
    var overlay = document.createElement('div');
    overlay.className = 'ugc-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="ugc-modal__close" aria-label="Fechar vídeo">' + ICON_CLOSE + '</button>' +
      '<button type="button" class="ugc-modal__nav ugc-modal__nav--prev" aria-label="Vídeo anterior">' + ICON_PREV + '</button>' +
      '<div class="ugc-modal__stage"></div>' +
      '<button type="button" class="ugc-modal__nav ugc-modal__nav--next" aria-label="Próximo vídeo">' + ICON_NEXT + '</button>';
    return overlay;
  }

  function initSection(root) {
    var track = root.querySelector('[data-ugc-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ugc-open]'));
    if (!track || !cards.length) return;

    var inlineVideos = cards
      .map(function (card) {
        return card.querySelector('video');
      })
      .filter(Boolean);

    var playback = setupInlinePlayback(root, track, inlineVideos);
    setupArrows(root, track, cards);
    setupModal(root, cards, playback);
  }

  function setupInlinePlayback(root, track, inlineVideos) {
    var mobile = isMobile();
    var initialPlay = mobile ? (isConstrainedDevice() ? 1 : 2) : inlineVideos.length;
    var intersecting = [];
    var unlocked = [];
    var modalOpen = false;

    function sync(index) {
      var video = inlineVideos[index];
      if (!video) return;
      if (!modalOpen && intersecting[index] && unlocked[index]) {
        play(video);
      } else {
        video.pause();
      }
    }

    function unlock(index) {
      if (index < 0 || index >= inlineVideos.length || unlocked[index]) return;
      unlocked[index] = true;
      var video = inlineVideos[index];
      if (video && video.getAttribute('preload') === 'none') {
        video.preload = 'metadata';
      }
      sync(index);
    }

    function unlockNext(fromIndex) {
      var next = fromIndex + 1;
      if (next >= inlineVideos.length) return;
      unlock(next);
      var nextVideo = inlineVideos[next];
      var nextItem = nextVideo && nextVideo.closest('.ugc__item');
      if (mobile && nextItem) {
        nextItem.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    inlineVideos.forEach(function (video, index) {
      intersecting[index] = !mobile && index < initialPlay;
      unlocked[index] = index < initialPlay;
      if (mobile) {
        video.loop = false;
        video.removeAttribute('loop');
      }
      if (mobile && index >= initialPlay) {
        video.pause();
        video.removeAttribute('autoplay');
        video.preload = 'none';
        try {
          video.currentTime = 0;
        } catch (error) {}
      }
      video.addEventListener('ended', function () {
        if (mobile) {
          unlockNext(index);
        } else {
          play(video);
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var index = inlineVideos.indexOf(entry.target);
            if (index < 0) return;
            intersecting[index] = entry.isIntersecting;
            if (entry.isIntersecting && mobile && track && track.scrollLeft > 8) {
              unlock(index);
            }
            sync(index);
          });
        },
        { threshold: 0.35 }
      );
      inlineVideos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      inlineVideos.forEach(function (video, index) {
        intersecting[index] = true;
        if (unlocked[index]) play(video);
      });
    }

    if (mobile && track) {
      track.addEventListener(
        'scroll',
        function () {
          if (track.scrollLeft <= 8) return;
          inlineVideos.forEach(function (video, index) {
            if (intersecting[index]) unlock(index);
          });
        },
        { passive: true }
      );
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        inlineVideos.forEach(function (video) {
          video.pause();
        });
      } else {
        inlineVideos.forEach(function (video, index) {
          sync(index);
        });
      }
    });

    return {
      setModalOpen: function (open) {
        modalOpen = open;
        inlineVideos.forEach(function (video, index) {
          if (open) {
            video.pause();
          } else {
            sync(index);
          }
        });
      }
    };
  }

  function setupArrows(root, track, cards) {
    var prev = root.querySelector('[data-ugc-prev]');
    var next = root.querySelector('[data-ugc-next]');
    if (!prev || !next) return;

    function step() {
      var card = cards[0].parentNode;
      var gap = parseInt(window.getComputedStyle(track).columnGap, 10) || 12;
      return card.offsetWidth + gap;
    }

    function sync() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var overflows = maxScroll > 4;
      prev.hidden = !overflows || track.scrollLeft <= 4;
      next.hidden = !overflows || track.scrollLeft >= maxScroll - 4;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function setupModal(root, cards, playback) {
    var overlay = null;
    var stage = null;
    var current = -1;
    var lastFocus = null;

    function render(index) {
      current = index;
      var card = cards[index];
      var source = card.querySelector('video');
      if (!source) return;

      stage.innerHTML = '';

      var video = source.cloneNode(true);
      video.classList.remove('ugc-card__video');
      video.muted = false;
      video.controls = true;
      video.loop = true;
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      video.removeAttribute('hidden');
      stage.appendChild(video);
      video.load();
      play(video);

      var href = card.getAttribute('data-ugc-link');
      if (href) {
        var cta = document.createElement('a');
        cta.className = 'ugc-modal__cta';
        cta.href = href;
        cta.textContent = card.getAttribute('data-ugc-link-label') || 'Ver produto';
        stage.appendChild(cta);
      }

      overlay.querySelector('.ugc-modal__nav--prev').hidden = index <= 0;
      overlay.querySelector('.ugc-modal__nav--next').hidden = index >= cards.length - 1;
    }

    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      stage.innerHTML = '';
      document.body.style.overflow = '';
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKeydown);
      if (playback && playback.setModalOpen) playback.setModalOpen(false);
      setTimeout(function () {
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        overlay = null;
        stage = null;
      }, 220);
      if (lastFocus) lastFocus.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft' && current > 0) render(current - 1);
      if (event.key === 'ArrowRight' && current < cards.length - 1) render(current + 1);
    }

    function open(index, trigger) {
      lastFocus = trigger;
      if (playback && playback.setModalOpen) playback.setModalOpen(true);

      overlay = createModal();
      stage = overlay.querySelector('.ugc-modal__stage');
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
      document.body.classList.add('overflow-hidden');

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) close();
      });
      overlay.querySelector('.ugc-modal__close').addEventListener('click', close);
      overlay.querySelector('.ugc-modal__nav--prev').addEventListener('click', function () {
        if (current > 0) render(current - 1);
      });
      overlay.querySelector('.ugc-modal__nav--next').addEventListener('click', function () {
        if (current < cards.length - 1) render(current + 1);
      });
      document.addEventListener('keydown', onKeydown);

      render(index);
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        overlay.querySelector('.ugc-modal__close').focus();
      });
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        open(index, card);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ugc]').forEach(function (root) {
      if (root.dataset.ugcReady) return;
      root.dataset.ugcReady = 'true';
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
